export default __webpack_public_path__ + "static/media/2B_360_1_alt.6ba8d936.jpg";